import Link from "next/link";
import WsrvImage from "../utils/WsrvImage";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";

const Footer = ({ footerData }) => {
  return (
    <>
      <div>
        {/* {JSON.stringify(footerData)} */}
        <footer className="bg-[#EEFBFF] pt-8 pb-4 mt-3">
          <section className="pb-8">
            <div className="container ">
              <div className="grid grid-cols-12 xl:gap-12 lg:gap-8 md:gap-6 gap-4 ">
                {footerData?.menus?.["footer_menu-2"]?.items?.[0]?.url && (
                  <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-3">
                    <div className="max-w-[600px] ">
                      <Link href="/" aria-label="CLC Home">
                        <WsrvImage
                          src={footerData.menus["footer_menu-2"].items[0].url}
                          alt="CLC Logo"
                          width={300}
                          height={146}
                          widths={[200, 300, 400, 600]}
                          sizes="(max-width: 768px) 100vw, 300px"
                          className="w-full h-auto"
                        />
                      </Link>
                    </div>
                  </div>
                )}
                {footerData?.menus?.ABOUT_CLC && (
                  <div className="col-span-12 md:col-span-4 lg:col-span-2 xl:col-span-2">
                    {footerData?.menus?.ABOUT_CLC?.title && (
                      <p className="text-base font-semibold mb-3 text-[#333]">
                        {footerData?.menus?.ABOUT_CLC?.title}
                      </p>
                    )}
                    {footerData?.menus?.ABOUT_CLC?.items.length > 0 && (
                      <ul className="space-y-1 ">
                        {footerData.menus?.ABOUT_CLC.items.map((itm, ind) => (
                          <li key={ind}>
                            <Link
                              href={itm.url}
                              target={itm.tab ? "_blank" : ""}
                              className="flex hover:text-[#54a897] text-[#000000] font-[436] text-lg  items-center"
                            >
                              {itm.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}

                {footerData?.menus?.COURSES && (
                  <div className="col-span-12 md:col-span-4 lg:col-span-2 xl:col-span-2">
                    {footerData?.menus?.COURSES?.title && (
                      <p className="text-base font-semibold mb-3 text-[#333]">
                        {footerData?.menus?.COURSES?.title}
                      </p>
                    )}
                    {footerData?.menus?.COURSES?.items.length > 0 && (
                      <ul className="space-y-1 ">
                        {footerData.menus?.COURSES.items.map((itm, ind) => (
                          <li key={ind}>
                            <Link
                              href={itm.url}
                              target={itm.tab ? "_blank" : ""}
                              className="flex hover:text-[#54a897] text-[#000000] font-[436] text-lg  items-center"
                            >
                              {itm.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}

                {footerData?.menus?.USEFUL_LINKS && (
                  <div className="col-span-12 md:col-span-4 lg:col-span-2 xl:col-span-2">
                    {footerData?.menus?.USEFUL_LINKS?.title && (
                      <p className="text-base font-semibold mb-3 text-[#333]">
                        {footerData?.menus?.USEFUL_LINKS?.title}
                      </p>
                    )}
                    {footerData?.menus?.USEFUL_LINKS?.items.length > 0 && (
                      <ul className="space-y-1 ">
                        {footerData.menus?.USEFUL_LINKS.items.map(
                          (itm, ind) => (
                            <li key={ind}>
                              <Link
                                href={itm.url}
                                target={itm.tab ? "_blank" : ""}
                                className="flex hover:text-[#54a897] text-[#000000] font-[436] text-lg  items-center"
                              >
                                {itm.title}
                              </Link>
                            </li>
                          )
                        )}
                      </ul>
                    )}
                  </div>
                )}

                {(footerData?.website?.address ||
                  footerData?.shortCodes?.OFFLINE_CENTER) && (
                  <div className="col-span-12 md:col-span-4 lg:col-span-2 xl:col-span-3">
                    <div className="flex space-x-4 items-center">
                      <div>
                        <div className="lg:text-center">
                          {/* <h2 className=" text-base font-normal mb-3 text-[#0B0B0B59] ">
                          About CLC
                        </h2> */}
                          <span className=" text-lg ">
                            {footerData?.website?.address}
                          </span>
                        </div>

                        <div>
                          <h2 className=" text-lg font-bold mt-3  lg:text-center ">
                            {footerData?.shortCodes?.OFFLINE_CENTER?.key}
                          </h2>
                          {footerData?.shortCodes?.OFFLINE_CENTER?.data.length >
                            0 && (
                            <div className="lg:text-center">
                              {footerData?.shortCodes?.OFFLINE_CENTER?.data.map(
                                (item, ind) => (
                                  <span className=" text-lg " key={ind}>
                                    {` ${item.title}`}
                                  </span>
                                )
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </section>
        </footer>
        <section className="">
          <div className="container ">
            <div className="flex flex-wrap justify-between xl:gap-8 lg:gap-6 gap-4 py-3">
              <div className="flex gap-4 text-[#000000]">
                {footerData?.menus?.COPYRIGHT_MENU?.items?.length > 0
                  ? footerData?.menus?.COPYRIGHT_MENU?.items.map(
                      (item, ind) => (
                        <div className="text-base" key={ind}>
                          <Link
                            href={item.url}
                            target={item.tab ? "_blank" : ""} rel={item.tab ? "noopener noreferrer" : undefined} rel={item.tab ? "noopener noreferrer" : undefined}
                            className="text-[#000000]"
                          >
                            {item.title}
                          </Link>
                        </div>
                      )
                    )
                  : null}
              </div>

              <div className="text-base text-[#000000]">
                <span className="mx-1"> © 2023 CLC Parivar.</span>
                {/* Design &  */}
                Developed By
                <Link href="https://edukitapp.com" className="text-base ml-1">
                  Edukit
                </Link>
              </div>
              {footerData?.website?.socialLinks && (
                <div className="text-xl flex flex-wrap items-center gap-4">
                  {footerData?.website?.socialLinks?.facebook && (
                    <Link
                      href={footerData?.website?.socialLinks?.facebook}
                      target="_blank" rel="noopener noreferrer"
                      aria-label="Facebook"
                      className="text-xl text-[#000000]"
                    >
                      <FaFacebookF />
                    </Link>
                  )}
                  {footerData?.website?.socialLinks?.twitter && (
                    <Link
                      href={footerData?.website?.socialLinks?.twitter}
                      target="_blank" rel="noopener noreferrer"
                      aria-label="Twitter"
                      className="text-xl text-[#000000]"
                    >
                      <FaTwitter />
                    </Link>
                  )}

                  {footerData?.website?.socialLinks?.linkedIn && (
                    <Link
                      href={footerData?.website?.socialLinks?.linkedIn}
                      target="_blank" rel="noopener noreferrer"
                      aria-label="LinkedIn"
                      className="text-xl text-[#000000]"
                    >
                      <FaLinkedinIn />
                    </Link>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Footer;
